import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import "./RecentReleases.css";
import SongDisplayList from "../../components/ViewAll/SongDisplayList";
import { SongAllDetails } from "../../types/SongTypes";
import { Link } from "react-router-dom";

interface SongsByMonth {
    [key: string]: SongAllDetails[];
}

const RecentReleases = () => {
    const [songsByMonth, setSongsByMonth] = useState<SongsByMonth | null>(null);
    const [error, setError] = useState<string | null>(null);
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const fetchRecentReleases = async () => {
            try {
                const response = await fetch("/api/songs/recent-releases");
                const json = await response.json();

                if (response.ok) {
                    setSongsByMonth(json);
                } else {
                    setError(response.status + " - " + json.error);
                }
            } catch (err) {
                setError("Failed to fetch recent releases");
            }
        };

        fetchRecentReleases();
    }, []);

    const formatMonth = (monthStr: string) => {
        const [year, month] = monthStr.split("-");
        const date = new Date(parseInt(year), parseInt(month) - 1);
        return date.toLocaleString("default", { month: "long", year: "numeric" }).toLowerCase();
    };

    if (error) {
        return <div className="error">{error}</div>;
    }

    if (!songsByMonth) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div className="recent-releases">
            <Helmet>
                <title>Recent Releases - dubu</title>
                <meta
                    name="description"
                    content={`View recent K-pop releases from ${currentYear} organized by month.`}
                />
            </Helmet>

            <div className="padding">
                <h1>{currentYear} song releases</h1>
                <Link to="/recent-releases-list" className="view-switch">
                    switch to list view
                </Link>

                {Object.entries(songsByMonth).map(([month, songs]) => (
                    <div key={month} className="month-section">
                        <h2>{formatMonth(month)}</h2>
                        <div className="display-list">
                            {songs.map((song) => (
                                <SongDisplayList
                                    key={song.song_id}
                                    song={song}
                                    name={song.english_name}
                                    s3_picture_url={song.s3_picture_url}
                                    year={new Date(song.release_date)}
                                    artist={song.artist_names}
                                    artist_ids={song.artist_ids}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentReleases; 